import { CreateFormModal } from 'components/create-form-modal'
import { ActionCompletedModal } from 'components/action-completed-modal'
import { SkillModal } from 'components/skill-modal'
import { PositionModal } from 'components/position-modal'
import { NewTeamModal } from 'components/new-team-modal'
import { InviteModal } from 'components/invite-modal'
import { MovePositionDialog } from 'components/move-position-dialog'
import { MoveTrackDialog } from 'components/move-track-dialog'
import { RequirementModal } from 'components/requirement-modal'
import { SelectRequirementModal } from 'components/select-requirement-modal'
import React from 'react'
import { useDrawerContext } from 'src/design-system'
import { SkillCopyDialog } from 'components/skill-copy-dialog'
const LazyCheckinCelebratoryModal = React.lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import('components/checkin-celebratory-modal').then((m) => ({
    default: m.CheckinCelebratoryModal,
  }))
)

const GlobalModals = () => {
  const { closeDrawer } = useDrawerContext()

  React.useEffect(() => {
    const handler = () => {
      closeDrawer()
    }

    document.addEventListener('turbo:click', handler)

    return () => {
      document.removeEventListener('turbo:click', handler)
    }
  })

  const shouldShowCelebrate = React.useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search)
      return params.has('celebrate_checkin')
    } catch {
      return false
    }
  }, [])

  return (
    <>
      <ActionCompletedModal />
      {shouldShowCelebrate && (
        <React.Suspense fallback={null}>
          <LazyCheckinCelebratoryModal />
        </React.Suspense>
      )}
      <CreateFormModal />
      <InviteModal />
      <MovePositionDialog />
      <MoveTrackDialog />
      <NewTeamModal />
      <PositionModal />
      <RequirementModal />
      <SelectRequirementModal />
      <SkillCopyDialog />
      <SkillModal />
    </>
  )
}

export default GlobalModals
